/**
 * The rules of the per-user AI limits (mirror of backend/core/ai/budget-rules.js, which enforces them again on the server and in the database):
 * Daily limit: default $10, at least $1. Monthly cap: empty = no monthly cap (not zero); when set, at least $25. Daily cannot exceed the monthly cap.
 */
export const DEFAULT_DAILY_LIMIT_USD = 10;
export const MIN_DAILY_LIMIT_USD = 1;
export const MIN_MONTHLY_CAP_USD = 25;
export const MAX_LIMIT_USD = 100000;

export type LimitsCheck = { ok: true; daily: number; monthly: number | null } | { ok: false; field: 'daily' | 'monthly'; message: string };

const blank = (text: string) => text.trim() === '';

export function checkLimits(dailyText: string, monthlyText: string): LimitsCheck {
  const daily = blank(dailyText) ? DEFAULT_DAILY_LIMIT_USD : Number(dailyText);
  if (!Number.isFinite(daily) || daily < MIN_DAILY_LIMIT_USD) return { ok: false, field: 'daily', message: `The daily limit must be at least $${MIN_DAILY_LIMIT_USD}.` };
  if (daily > MAX_LIMIT_USD) return { ok: false, field: 'daily', message: `The daily limit cannot be more than $${MAX_LIMIT_USD.toLocaleString('en-US')}.` };
  let monthly: number | null = null;
  if (!blank(monthlyText)) {
    monthly = Number(monthlyText);
    if (!Number.isFinite(monthly) || monthly < MIN_MONTHLY_CAP_USD) return { ok: false, field: 'monthly', message: `The monthly cap must be at least $${MIN_MONTHLY_CAP_USD}, or empty for no monthly cap.` };
    if (monthly > MAX_LIMIT_USD) return { ok: false, field: 'monthly', message: `The monthly cap cannot be more than $${MAX_LIMIT_USD.toLocaleString('en-US')}.` };
    if (daily > monthly) return { ok: false, field: 'daily', message: 'The daily limit cannot be higher than the monthly cap. Lower the daily limit or raise the monthly cap.' };
  }
  return { ok: true, daily, monthly };
}
